'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import CurrencySelect from 'ui-addon-i18n/components/CurrencySelect';
import Small from 'UIComponents/elements/Small';
import UISelect from 'UIComponents/input/UISelect';
import UIAlert from 'UIComponents/alert/UIAlert';
import httpClient from 'hub-http/clients/apiClient';
import UIValidatedEmailFormControl from 'ui-addon-form-validation/Email/UIValidatedEmailFormControl';
import groupsToSelectOpts from 'timezone-utils/utils/groupsToSelectOpts';
import getTimezoneGroups from 'timezone-utils/utils/getTimezoneGroups';

const AdwordsAdAccountForm = ({
  adAccountName,
  email,
  currency,
  onAdAccountNameChange,
  onEmailChange,
  onTimeZoneChange,
  onCurrencyChange,
  emailErrorHandler,
  emailSuccessHandler,
  error
}) => {
  return /*#__PURE__*/_jsxs(UIForm, {
    "data-test-id": "adwords-ad-creation",
    children: [!!error && /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.adCreationError"
      }),
      type: "danger",
      children: error
    }), /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.adAccountName"
      }),
      children: /*#__PURE__*/_jsx(UITextInput, {
        value: adAccountName,
        onChange: onAdAccountNameChange,
        "data-test-id": "ad-account-name"
      })
    }), /*#__PURE__*/_jsx(UIValidatedEmailFormControl, {
      httpClient: httpClient,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.email"
      }),
      type: "basic",
      onError: emailErrorHandler,
      onSuccess: emailSuccessHandler,
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UITextInput, {
          value: email,
          onChange: onEmailChange,
          "data-test-id": "email-address"
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.emailNote"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.timezone"
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        onChange: onTimeZoneChange,
        options: groupsToSelectOpts(getTimezoneGroups()),
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.timezonePlaceholder"
        })
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.currency"
      }),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(CurrencySelect, {
          "data-test-id": "currency-select",
          currencyStyle: "long",
          defaultValue: "USD",
          onChange: onCurrencyChange,
          value: currency,
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.currencyPlaceholder"
          })
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.adwordsSetup.currencyNote"
          })
        })]
      })
    })]
  });
};

export default AdwordsAdAccountForm;